// Backend Users translations for React Admin resource
export const backendUsersResource = {
  name: '管理員',
  fields: {
    id: 'ID',
    username: '使用者名稱',
    email: '電子郵件',
    roleId: '角色',
    isActive: '啟用',
    totpEnabled: '雙重驗證',
    lastLoginAt: '最後登入',
    failedLoginAttempts: '失敗次數',
    lockedUntil: '鎖定至',
    language: '語言',
    vendor: '商戶',
    vendorId: '商戶',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    password: '密碼',
    requirePasswordChange: '首次登入時要求更改密碼',
  },
  noVendor: '無商戶',
};

// Custom backend users translations for components
export const backendUsers = {
  list: {
    title: '後台使用者',
    filters: {
      search: '搜尋使用者名稱或電子郵件',
      activeOnly: '僅顯示啟用',
      role: '角色',
      language: '語言',
    },
    empty: {
      title: '找不到使用者',
      subtitle: '創建您的第一個後台使用者來管理系統。',
    },
  },
  edit: {
    title: '編輯使用者',
    basicInfo: '基本資訊',
    securitySettings: '安全設定',
    accountStatus: '帳戶狀態',
    deleteAccount: '刪除帳戶',
    deleteAccountDescription: '永久刪除此使用者帳戶和所有相關數據',
    cannotDeleteOwnAccount: '您不能刪除自己的帳戶',
    activeAccount: '啟用帳戶',
    twoFactorAuth: '雙重驗證',
    twoFactorHelpText: '使用者可以從其個人資料中啟用/停用雙重驗證',
    admin2faDisableHelp: '如果使用者無法訪問其驗證器，您可以為此使用者停用雙重驗證',
    admin2faEnableHelp: '使用者必須從其個人資料中自行啟用雙重驗證 - 這確保了正確的驗證器設置',
    admin2faDisableWarning: '您即將為此使用者停用雙重驗證。',
    admin2faDisableMessage: '這將從 %{username} (%{email}) 中移除雙重驗證保護。如果他們想要重新啟用，將需要重新設置。',
    admin2faDisableReason: '只有在使用者無法訪問其驗證設備時才應執行此操作。',
    admin2faOwnAccountWarning: '您不能在此處修改自己的雙重驗證設定。請改用您的個人資料頁面。',
    admin2faUserNoTwoFactor: '此使用者尚未啟用雙重驗證。使用者必須從其個人資料中自行啟用雙重驗證。',
    passwordManagement: '密碼管理',
    passwordResetHelp: '要重置使用者的密碼，請使用"發送密碼重置電子郵件"操作或手動提供臨時密碼。',
    lastLogin: '最後登入',
    failedLoginAttempts: '登入失敗次數',
    accountLockedUntil: '帳戶鎖定至',
    accountUnlockHelp: '帳戶將在此時間後自動解鎖',
    deleteConfirmTitle: '刪除使用者',
    deleteConfirmWarning: '警告：此操作無法撤銷。',
    deleteConfirmMessage: '您即將刪除使用者',
    deleteConfirmInfo: '所有相關數據將被永久刪除。',
    deleteConfirmPrompt: '要確認刪除，請輸入使用者名稱',
    deleteConfirmPromptBelow: '如下：',
    deleteConfirmTypePlaceholder: '輸入 "%{username}" 以確認',
    usernameDoesNotMatch: '使用者名稱不匹配',
    deleteButton: '刪除使用者',
    backToList: '返回列表',
    vendorAssignment: '商戶分配',
    vendorHelperText: '更改商戶分配或留空以移除商戶訪問權限。',
    vendorAssignmentInfo: '更改商戶分配將影響此使用者可以訪問的數據。移除商戶分配使他們成為系統管理員。',
  },
  create: {
    title: '創建使用者',
    subtitle: '添加新的後台管理員',
    infoMessage: '創建具有管理訪問權限的新後台使用者。使用者將收到包含登入說明的電子郵件。',
    basicInfo: '基本資訊',
    securitySettings: '安全設定',
    usernameHelperText: '用於登入的唯一使用者名稱',
    emailHelperText: '使用者將在此電子郵件收到登入說明',
    roleHelperText: '決定使用者權限',
    temporaryPassword: '臨時密碼',
    passwordHelperText: '必須包含至少 8 個字符，包括大寫、小寫、數字和特殊字符',
    generatePassword: '產生密碼',
    passwordGenerated: '已產生密碼',
    passwordGeneratedCopied: '已產生密碼並複製到剪貼簿',
    passwordValidation: {
      minLength: '必須包含至少一個大寫字母',
      uppercase: '必須包含至少一個大寫字母',
      lowercase: '必須包含至少一個小寫字母',
      number: '必須包含至少一個數字',
      special: '必須包含至少一個特殊字符',
    },
    requirePasswordChange: '首次登入時要求更改密碼',
    twoFactorInfo: '雙重驗證',
    twoFactorHelperText: '使用者可以在登入後從其個人資料啟用雙重驗證。這為其帳戶提供了額外的安全層。',
    vendorAssignment: '商戶分配（可選）',
    vendorHelperText: '將此使用者分配給商戶組織。系統管理員應留空。',
    vendorAssignmentInfo: '將使用者分配給商戶使他們只能管理該商戶的 RFID 卡片和查看數據。系統管理員不應分配給商戶。',
  },
  notifications: {
    deleteSuccess: '使用者刪除成功',
    deleteError: '刪除使用者時發生錯誤',
    createSuccess: '使用者創建成功',
    updateSuccess: '使用者更新成功',
    error: {
      create: '創建使用者失敗',
      update: '更新使用者失敗',
      delete: '刪除使用者失敗',
    },
  },
  status: {
    active: '啟用',
    inactive: '停用',
  },
  actions: {
    create: '創建使用者',
    save: '保存使用者',
    delete: '刪除使用者',
    cancel: '取消',
    sendPasswordReset: '發送密碼重置電子郵件',
    disable2FA: '停用雙重驗證',
    unlockAccount: '解鎖帳戶',
    actions: '操作',
    resetPassword: '重設密碼',
  },
  twoFactorAuth: {
    confirmDisable: '您確定要為此使用者停用雙重驗證嗎？',
    disabledSuccess: '雙重驗證已成功停用',
    disabledError: '停用雙重驗證失敗',
  },
  passwordReset: {
    sectionTitle: '密碼',
    adminHelp: '重設此用戶的密碼。可選擇系統隨機產生強密碼，或自行設定指定密碼。',
    ownAccountHelp: '請使用「我的個人資料」中的「變更密碼」功能來變更自己的密碼。',
    ownAccountTooltip: '請使用「我的個人資料」中的「變更密碼」功能來變更自己的密碼。',
    confirmTitle: '確定要重設此用戶的密碼？',
    confirmWarningTitle: '此操作將：',
    confirmBullet1: '覆寫該用戶的現有密碼',
    confirmBullet2: '將該用戶從所有作業中的工作階段登出',
    confirmBullet3: '清除該帳戶因登入失敗而觸發的鎖定',
    confirmBodyRandom: '臨時密碼僅顯示一次。請即時複製並透過安全的渠道交付給用戶。',
    confirmBodyCustom: '用戶需要使用此密碼登入。請確保透過安全的渠道交付密碼。',
    modeLabel: '新密碼',
    modeRandom: '系統隨機產生強密碼（僅顯示一次）',
    modeCustom: '自行設定密碼',
    passwordLabel: '新密碼',
    confirmLabel: '確認新密碼',
    passwordHint: '至少 8 個字元，需包含大寫、小寫、數字以及至少一個特殊符號',
    passwordTooShort: '至少需要 8 個字元',
    passwordWeak: '需包含大寫、小寫、數字以及至少一個特殊符號',
    confirmMismatch: '兩次輸入的密碼不一致',
    cancel: '取消',
    confirm: '重設密碼',
    resultTitle: '臨時密碼',
    resultTitleCustom: '密碼已重設',
    resultWarning: '此密碼僅會顯示一次。請即時複製並透過安全的渠道交付給用戶。',
    customSuccess: '密碼已設定。該用戶已被登出，需使用新密碼重新登入。',
    done: '完成',
    failed: '密碼重設失敗',
    copy: '複製',
    copied: '已複製！',
  },
};